@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<h1>
  @switch(editing) {
    @case(true) {
      <span>Edit Channel {{platformId}}</span>
    }
    @case(false) {
      <span>Register a new Channel</span>
    }
  }
</h1>
<form name="channelConversionForm" class="form-horizontal" [formGroup]="channelConversionForm">
  <div class="form-group">
    <label for="itemId"> Channel Id: </label>
    <input type="text" id="itemId" class="form-control" name="itemId" formControlName="id" required />
    @if(channelConversionForm.get('id')?.invalid && (channelConversionForm.get('id')?.dirty || channelConversionForm.get('id')?.touched)) {
      <div class="text-danger">
        <div *ngIf="channelConversionForm.get('id')?.errors?.['required']">Channel ID is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="itemDescription"> Item description: </label>
    <input type="text" id="itemDescription" class="form-control" name="itemDescription" formControlName="displayLabel" required />
    @if(channelConversionForm.get('displayLabel')?.invalid && (channelConversionForm.get('displayLabel')?.dirty || channelConversionForm.get('displayLabel')?.touched)) {
      <div class="text-danger">
        <div *ngIf="channelConversionForm.get('displayLabel')?.errors?.['required']">Item description is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="itemUnit"> Item unit: </label>
    <select id="itemUnit" class="form-control" name="itemUnit" type="select" required (change)="setItem($event.target)">
      <option disabled selected value=></option>
      @for(u of item_units; track u ) {
        <option [value]="u" [selected]="channelDto.itemUnit === u">{{u}}</option>
      }
    </select>
    @if(channelConversionForm.get('itemUnit')?.invalid && (channelConversionForm.get('itemUnit')?.dirty || channelConversionForm.get('itemUnit')?.touched)) {
      <div class="text-danger">
        <div *ngIf="channelConversionForm.get('itemUnit')?.errors?.['required']">Item unit is required.</div>
      </div>
    }
  </div>

  <div class="form-group">
    <label for="scale_code"> SI Scale Code: </label>
    <select  name="si_scale_codes" id="scale_code" class="form-control" type="select" (change)="setSiScaleCode($event.target)">
      <option disabled selected value=></option>
      @for(sc of si_scale_codes; track sc) {
        <option [value]="sc.value" [selected]="channelDto.siScaleCode === sc.value">{{sc.documentation}} ( {{sc.value}} )</option>
      }
    </select>
    @if(channelConversionForm.get('scale_code')?.invalid && (channelConversionForm.get('scale_code')?.dirty || channelConversionForm.get('scale_code')?.touched)) {
      <div class="text-danger">
        <div *ngIf="channelConversionForm.get('scale_code')?.errors?.['required']">Scale Code is required.</div>
      </div>
    }
  </div>
  @if(isAdmin) {
    <div class="row">
      <div class="span3" style="text-align:right;">
        <button id="addConversion" class="btn btn-primary" type="button" (click)="addConversion()">Add conversion</button>
      </div>
    </div>
  }
  <table class="table table-striped">
    <thead>
    <tr>
      <th colspan="7">
        <input name="search"  placeholder="Search by Conversion name" class="input-sm form-control" type="search" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}"/>
      </th>
    </tr>
    <tr>
      <th>Conversions (optional)</th>
      <th>Powertypes</th>
      <th>&nbsp;</th>
    </tr>
      @for(channel_powertype of displayedChannelPowerTypes | searchFilterPipe : searchText : 'conversion.description'; track $index) {
        <tr>
          <td>
            <select name="conversions" class="form-control input-sm" type="select" (change)="setConversion($event.target, $index)">
              <option disabled selected value=></option>
              @for(conver of conversions; track conver) {
                <option [value]="conver.id" [selected]="channel_powertype.conversion?.id === conver.id">{{conver.description}}</option>
              }
            </select>
          </td>
          <td>
            <select  name="powerTypes" class="form-control input-sm" type="select" (change)="setPowerType($event.target, $index)">
              <option disabled selected value=></option>
              @for(powerType of powerTypes; track powerType) {
                <option [value]="powerType.itemDescription" [selected]="channel_powertype.powertype?.itemDescription === powerType.itemDescription" >
                  {{powerType.itemLabel}} ({{powerType.siScaleCode}}{{powerType.itemUnit}}) {{powerType.hertz}}Hz {{powerType.voltage}}V
                </option>
              }
            </select>
          </td>
          @if(isAdmin){
            <td>
              <button class="btn btn-danger" type="button" (click)="deleteConversion($index)">Delete</button>
            </td>
          }
        </tr>
      }
      @if(displayedChannelPowerTypes.length === 0){
        <tr>
          <td colspan="10" style="text-align: center;"> No Channel Conversions created yet.</td>
        </tr>
      }
    </thead>
  </table>
  <div class="row">
    <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="channelConversionForm.invalid">Save</button>
    <a class="btn" (click)="backPage('/channels', router)">Cancel</a>
  </div>
</form>
